import React from "react";

const LogoComponent = ({fill}) =>{
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="50.000000pt" height="50.000000pt" viewBox="0 0 1000.000000 1000.000000"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,1000.000000) scale(0.100000,-0.100000)"
        fill={fill} stroke="none">
        <path d="M4700 9454 c-60 -5 -234 -22 -345 -35 -224 -25 -633 -129 -905 -231
        -969 -362 -1754 -1020 -2294 -1921 -288 -482 -489 -1051 -571 -1622 -35 -246
        -39 -310 -39 -640 -1 -334 3 -387 40 -655 161 -1145 797 -2214 1739 -2920 390
        -292 830 -520 1290 -670 764 -248 1563 -286 2355 -113 426 93 910 280 1265
        490 445 264 799 556 1125 928 542 620 898 1366 1039 2185 46 271 55 389 55
        760 0 381 -10 502 -69 815 -163 879 -597 1701 -1229 2330 -154 152 -337 312
        -503 436 -396 297 -920 557 -1409 698 -191 56 -458 113 -604 130 -52 6 -131
        16 -175 22 -78 10 -676 20 -765 13z m620 -234 c90 -6 192 -15 225 -20 245 -39
        341 -57 490 -95 296 -75 422 -120 739 -263 202 -91 353 -175 581 -327 262
        -173 447 -327 680 -566 590 -605 1003 -1412 1134 -2214 37 -229 41 -261 53
        -493 12 -241 1 -628 -23 -787 -62 -409 -120 -637 -249 -980 -160 -426 -444
        -897 -749 -1245 -389 -444 -884 -820 -1381 -1051 -281 -130 -513 -214 -780
        -282 -154 -39 -254 -59 -495 -97 -94 -15 -364 -30 -535 -30 -638 1 -1174 114
        -1750 372 -193 86 -275 129 -424 220 -386 236 -659 459 -954 778 -645 697
        -1041 1616 -1102 2559 -23 357 -7 696 51 1031 110 643 381 1275 771 1797 207
        278 502 580 784 805 95 76 356 251 504 338 195 115 570 284 788 354 298 96
        685 175 962 195 156 12 493 12 680 1z"/>
        <path d="M4700 9094 c-329 -21 -711 -101 -1050 -219 -188 -66 -259 -94 -411
        -167 -1112 -533 -1917 -1517 -2219 -2713 -40 -156 -75 -356 -101 -570 -18
        -146 -19 -712 -1 -850 37 -286 83 -516 142 -718 188 -644 544 -1255 997 -1712
        574 -581 1263 -970 2016 -1141 105 -24 133 -30 273 -54 280 -48 825 -61 1109
        -26 428 52 717 124 1075 268 753 303 1434 856 1877 1523 377 567 591 1158 675
        1860 17 149 17 714 0 855 -90 707 -292 1273 -648 1815 -428 651 -1014 1157
        -1724 1487 -172 80 -545 211 -705 248 -429 99 -619 120 -1025 118 -129 -1
        -255 -3 -280 -4z m-1031 -810 c294 -193 426 -306 526 -449 134 -192 292 -498
        365 -710 111 -320 160 -688 131 -970 -18 -169 -61 -609 -61 -622 0 -6 57 12
        135 43 193 77 378 146 550 203 179 59 621 195 687 212 26 6 52 16 57 23 30 37
        42 739 16 981 -36 338 -117 660 -218 860 -31 63 -59 98 -132 170 -124 121
        -140 145 -125 189 6 18 21 43 35 56 21 20 27 21 58 11 18 -6 45 -24 58 -39 68
        -75 232 -319 285 -424 98 -194 163 -456 200 -801 13 -124 15 -218 10 -507 -3
        -195 -9 -378 -12 -407 l-6 -52 148 40 c82 21 187 49 234 60 148 36 260 14 268
        -53 4 -34 -46 -91 -97 -112 -48 -19 -202 -49 -336 -66 -55 -7 -129 -18 -165
        -25 l-65 -11 -12 -95 c-52 -385 -127 -824 -194 -1129 -186 -849 -603 -2332
        -797 -2829 -46 -118 -91 -171 -145 -171 -28 0 -40 6 -53 25 -42 64 -25 147 71
        355 113 245 165 394 320 930 320 1101 503 1889 609 2632 19 128 32 235 30 237
        -17 18 -928 -287 -1249 -417 -188 -76 -195 -80 -195 -110 0 -49 -80 -584 -106
        -707 -30 -143 -64 -265 -99 -360 -99 -267 -338 -760 -456 -940 -127 -193 -315
        -362 -507 -453 -68 -33 -88 -37 -169 -40 -114 -5 -158 13 -231 93 -176 192
        -282 498 -284 820 -1 112 24 221 92 400 120 318 252 511 494 719 156 135 330
        232 846 473 129 61 242 113 252 116 22 8 25 33 69 552 31 364 4 734 -72 1000
        -68 238 -241 574 -412 800 -112 149 -175 203 -332 282 -161 82 -202 109 -221
        144 -18 35 -18 51 0 94 14 34 17 35 67 35 46 0 61 -6 138 -56z"/>
        <path d="M4365 5233 c-111 -46 -479 -229 -600 -298 -414 -236 -626 -486 -767
        -909 -71 -212 -83 -335 -48 -506 48 -238 165 -472 256 -515 31 -15 40 -15 94
        -1 33 9 88 30 122 47 233 117 369 292 626 804 223 448 271 602 341 1110 17
        121 33 237 36 258 3 20 4 37 3 36 -2 0 -30 -12 -63 -26z"/>
        </g>
        </svg>
    );
}

export default LogoComponent;